module.exports = "/img/item-12.386c35fc.png";